import styled from "@emotion/styled";
import { Checkbox, EditModal, Input, Title } from "@src/components";
import React, { Dispatch, SetStateAction } from "react";

interface UserAdTicketRefundModalProps {
    isShowAdTicketRefundModal: boolean;
    setIsShowModal: (isShow: boolean) => void;
    AdTicketDetailData: any;
    adTicketRefundState: {
        ticketNo: number;
        refundPrice: number;
        reason: string;
    };
    setAdTicketRefundState: Dispatch<
        SetStateAction<{
            ticketNo: number;
            refundPrice: number;
            reason: string;
        }>
    >;
    setIsShowAdTicketRefundConfirmModal: (isShow: boolean) => void;
}

const UserAdTicketRefundModal = ({
    isShowAdTicketRefundModal,
    setIsShowModal,
    AdTicketDetailData,
    adTicketRefundState,
    setAdTicketRefundState,
    setIsShowAdTicketRefundConfirmModal,
}: UserAdTicketRefundModalProps) => {
    return (
        <>
            <EditModal
                isModalShow={isShowAdTicketRefundModal}
                buttonText="저장"
                handleBtnClick={() => {
                    // setIsCheckModalShow(true);
                    // setDeungiType("refund");
                    setIsShowAdTicketRefundConfirmModal(true);
                    setIsShowModal(false);
                }}
                handleOpenModal={() => {
                    setIsShowModal(false);
                }}
                size="big"
                title="등기열람권 환불"
                // isDisabled={
                //     !deungiRefundPrice ||
                //     !reason ||
                //     Boolean(!refundQuantity && deungiRefundPrice === "0")
                // }
            >
                <StyledWrap>
                    <StyledContens>
                        <div className="row">
                            <div>
                                충전정보{" "}
                                <span>
                                    {AdTicketDetailData?.productName} 충전
                                </span>
                            </div>
                            <div>
                                결제액{" "}
                                <span>
                                    {AdTicketDetailData?.paidPrice.toLocaleString()}
                                </span>
                            </div>
                        </div>
                        <div className="row">
                            <div>
                                사용 수량
                                <span>{AdTicketDetailData?.usedQuantity}</span>
                            </div>
                        </div>
                    </StyledContens>
                    <StyledRefundInfo>
                        <Title title="환불정보" />
                        <div className="row">
                            <div>
                                환불 수량{" "}
                                <span>
                                    {AdTicketDetailData?.refundQuantity}
                                </span>
                            </div>
                            <div>
                                <span className="star">*</span>환불예정액{" "}
                                <Input
                                    errorMessage=""
                                    handleChange={(e) => {
                                        const onlyNumber =
                                            e.target.value.replace(
                                                /[^0-9]/g,
                                                "",
                                            );
                                        setAdTicketRefundState({
                                            ...adTicketRefundState,
                                            refundPrice: Number(onlyNumber),
                                        });
                                    }}
                                    onKeyDown={function noRefCheck() {}}
                                    placeholder="금액 입력"
                                    size="medium"
                                    type="text"
                                    value={
                                        adTicketRefundState?.refundPrice ?? ""
                                    }
                                />
                                <Checkbox
                                    defaultValue=""
                                    handleChange={(key, check) => {
                                        check &&
                                            AdTicketDetailData?.paidPrice &&
                                            setAdTicketRefundState({
                                                ...adTicketRefundState,
                                                refundPrice:
                                                    AdTicketDetailData?.paidPrice,
                                            });
                                    }}
                                    label="전액환불"
                                />
                            </div>
                        </div>
                        <StyledReasonWrapper>
                            <span>
                                <span className="essential">*</span>사유
                            </span>
                            <input
                                type="text"
                                placeholder="사유를 작성해 주세요"
                                onChange={(e: any) => {
                                    setAdTicketRefundState({
                                        ...adTicketRefundState,
                                        reason: e.target.value,
                                    });
                                }}
                                value={adTicketRefundState?.reason ?? ""}
                            />
                        </StyledReasonWrapper>
                    </StyledRefundInfo>
                </StyledWrap>
            </EditModal>
        </>
    );
};

export default UserAdTicketRefundModal;

const StyledWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 35px;
`;

const StyledContens = styled.div`
    display: flex;
    flex-direction: column;
    gap: 35px;
    & > .row {
        display: flex;
        & > div {
            width: 50%;
            & > span {
                margin-left: 15%;
            }
        }
    }
`;

const StyledRefundInfo = styled.div`
    margin-bottom: 25px;
    & > .row {
        display: flex;
        margin-top: 15px;
        & > div {
            width: 50%;
            display: flex;
            align-items: center;
            & > .star {
                color: #f45b5b;
                margin-left: 0;
            }
            & > span {
                margin-left: 15%;
            }

            & > input {
                margin-left: 20px;
                width: 50%;
                margin-right: 10px;
            }
        }
    }
`;

const StyledReasonWrapper = styled.div`
    position: absolute;
    bottom: 20px;
    width: 648px;
    height: 48px;
    display: flex;
    gap: 16px;
    align-items: center;
    & > span {
        font-weight: 400;
        font-size: 13px;
        width: 80px;
        .essential {
            color: #f45b5b;
        }
    }
    & > input {
        height: 100%;
        width: calc(100% - 296px);
        padding: 12px;
        font-weight: 400;
        font-size: 14px;
        line-height: 170%;
        color: #283237;
        border: 1px solid #e3e3e6;
        border-radius: 8px;
        outline: none;
    }
`;
